import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { styled } from '@linaria/react';
import { useUrlUpdater } from 'components/data/WithUrlUpdater';
import { Button } from '@daedalus/atlas/Button';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { Icon } from '@daedalus/atlas/Icon';
import { useTrackingTeam } from '@daedalus/core/src/analytics/hooks/useTrackingTeam';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY } from '@daedalus/core/src/auth/modules/actions';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { useSrpQueryString } from './helpers';
const ButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ButtonWrapper",
  class: "baft9fp",
  propsAsIs: false
});
export const GoBackToSearchButton = () => {
  const match = useRouteMatch<{
    hotelSlug: string;
  }>();
  const {
    changeLocation
  } = useUrlUpdater();
  const team = useTrackingTeam();
  const dispatch = useDispatch();
  const query = useSrpQueryString(match.params.hotelSlug);
  const handleBackToSearch = useCallback(() => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.HotelDetailsBackButton,
      action: Action.Clicked,
      team
    }));

    // timeout to allow the tracking event to be sent before navigating away
    setTimeout(() => {
      changeLocation(query);
    }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY);
  }, [changeLocation, query, dispatch, team]);
  return <ButtonWrapper onClick={handleBackToSearch}>
      <Button variant="secondary" isRounded size="md" iconStart={<Icon name="ChevronLeft" />} />
      <ButtonLink>
        <FormattedMessageWrapper id="returnToSearch" defaultMessage="Go back to search" />
      </ButtonLink>
    </ButtonWrapper>;
};

require("./BackToSearchButton.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BackToSearchButton.tsx");